/* @flow strict */

import * as React from 'react';
import CreateEditEvent from '../';
import NavbarTitleBackAction from './components/createEditNavbarTitleBackAction';
import { withRouter } from 'react-router';
import StepNavBar from '../stepNavbar';
import EventPageDesign from './newDesign';
import NewCollaborators from './newCollaborators';
import NewShare from './newShare';
import { ToggleLeftMenu } from '/client/src/utils/animation';
import EventDetailContainer from '/client/src/container/eventDetails';

type CreateEventPropsType = {
  match: {
    params: {
      eventId?: string | number,
      viewTab?: string
    }
  }
};


class CreateEvent extends React.Component<CreateEventPropsType> {
  props: CreateEventPropsType;


  constructor(props: CreateEventPropsType) {
    super(props);

    let step = 1;

    switch (props.match.params.viewTab) {
      case 'design':
        step = 2;
        break;
      case 'collaborators':
        step = 3;
        break;
      case 'share':
        step = 4;
        break;
      default:
        step = 1;
    }

    this.state = {
      step
    };
  }

  componentDidMount() {
    ToggleLeftMenu('hide');
    this.setPrevPath();
    this.setState({
      isNew: !this.props.match.params.eventId
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.step !== this.state.step) {
      this.setPrevPath();
    }
    if (prevProps.match.params.eventId !== this.props.match.params.eventId) {
      this.setState({
        isNew: !this.props.match.params.eventId
      });
    }
  }

  componentWillUnmount() {
    ToggleLeftMenu('show');
  }

  handleChangeStepNavBar = (step: number) => {
    this.setState({ step });
  };

  setPrevPath = (): string => {
    let prevPath = '';
    const { step } = this.state;

    switch (step) {
      case 2:
        prevPath = 'edit-new';
        break;
      case 3:
        prevPath = 'design';
        break;
        case 4:
        prevPath = 'collaborators';
        break;
      default:
        break;
    }
    this.setState({
      prevPath
    });
  };

  handlePreviousStep = () => {
    this.setState((prevState: {}): void => ({
      step: prevState.step > 1 ? prevState.step - 1 : 1
    }));
  }

  wrapper = (children: any): any => {
     if (this.state.isNew) {
      return (
        <div className="sparxo-router-content">
          <div className="sparxo-page-container EventDetailContainer">
          { children }
          </div>
        </div>
      );
     }
      return (
        <EventDetailContainer hideNavBar >
          {children}
        </EventDetailContainer>
      );
   }


  render(): React.Fragment {
    const { step, prevPath } = this.state;

    return (
      <>
        <NavbarTitleBackAction prevPath={prevPath} onBack={this.handlePreviousStep} />

        <StepNavBar step={step} />

        <>
          {
            this.wrapper(
              <>
                {step === 1 &&
                  <CreateEditEvent
                    onHandleChangeStepNavBar={(): void => this.handleChangeStepNavBar(2)}
                    eventId={this.props.match.params.eventId}
                  />
                }

                {step === 2 &&
                  <EventPageDesign onHandleChangeStepNavBar={this.handleChangeStepNavBar} {...this.props} />
                }

                {step === 3 &&
                  <NewCollaborators
                    eventId={this.props.match.params.eventId}
                    onHandleChangeStepNavBar={this.handleChangeStepNavBar}
                    {...this.props}
                  />
                }

                {step === 4 &&
                <NewShare
                  eventId={this.props.match.params.eventId}
                  onHandleChangeStepNavBar={this.handleChangeStepNavBar}
                  {...this.props}
                />
                }
              </>
            )
          }
        </>
      </>
    );
  }
}

export default withRouter(CreateEvent);
